import React from "react";
import AboutContent from "../component/aboutContent/AboutContent";

const About = () => {
  return (
    <div>
      <AboutContent />
    </div>
  );
};

export default About;
